<template>
    <div class="pre-container">
        <div class="pre-wrap" :class="{ 'pre-warp--cbt': cbtShow }">
            <img src="../assets/images/pre/logo.png" class="logo" alt="">

            <div class="toggle-box">
                <div class="toggle-btn toggle-btn--pre" :class="{ 'active': !cbtShow  }" @click="toggleBox('pre')">
                    <img src="../assets/images/pre/pre_btn_open.png" alt="">
                </div>
                <div class="toggle-btn toggle-btn--cbt" :class="{ 'active': false  }" @click="toggleBox('cbt')">
                    <img :src="cbtBtn" alt="">
                </div>
            </div>
            
            <!-- pre-content -->
            <div class="pre-content" v-show="!cbtShow">
                <div class="input-wrap">
                    <div class="input-email">
                        <input type="text" v-model="email" placeholder="Your Email Address">
                    </div>
                    <div class="check-box">
                        <input class="check-input" type="text" v-model="code" placeholder="Verfication Code">
                        <div class="check-btn" :class="{ 'wait': waitCode_show }" v-debounce="check">
                            <img src="../assets/images/pre/send_code.png" class="send-code" alt="">
                            <div v-show="waitCode_show" class="wait-code">
                                <p>({{waitTime}}s)</p>
                            </div>
                        </div>
                    </div>
                    <div class="cert-box">
                        <input type="checkbox" v-model="checkVal" name="" id="">
                        <p>Agree to the 
                            <router-link to="/terms_of_service">TERMS OF SERVICE</router-link> and <router-link to="/privacy_policy">PRIVACY POLICY</router-link>.
                        </p>
                    </div>
                </div>
                <div class="pre-reg-box" :class="{ 'finsh': prereg_finsh }" >
                    <img src="../assets/images/pre/pre-register.png" alt="">
                    <div class="pre-reg-box-click" v-debounce="preBtn"></div>
                </div>
                <div class="goal-box">
                    <div class="goal" v-for="(item, index) in goalList" :key="`goal-${index}`">
                        <img src="../assets/images/pre/goal.png" alt="">
                        <div class="goal-proce" :style="goalProcess(item.num, index)"></div>
                        <p class="goal-tip">{{ item.text }}</p>
                    </div>
                </div>
                <div class="award-box">
                    <div class="award" v-for="(item, index) in goalList" :key="`award-${index}`">
                        <img :src="awardImg(item)" alt="">
                    </div>
                    <div class="award">
                        <img src="../assets/images/pre/goal_other01.png" alt="">
                    </div>
                    <div class="award">
                        <img src="../assets/images/pre/goal_other02.png" alt="">
                    </div>
                </div>
            </div>
            <!-- cbt-content -->
            <div class="cbt-content" v-show="cbtShow">
                <div class="cbt-box">
                    <p class="cbt-box-tip--close">CBT registration is closed</p>
                    <!-- <p class="cbt-box-tip">Please enter your Google Play email account.</p> -->
                    <!-- <div class="cbt-box-btn"> -->
                        <!-- <div class="cbt-checkbox-box">
                            <div class="android-checkbox-box">
                                <input type="radio" value="android" class="cbt-checkbox" v-model="cbtChannel" name="channel">
                                <label for="channel">Android</label>
                            </div>
                            <div class="ios-checkbox-box">
                                <input type="radio" value="ios" class="cbt-checkbox" v-model="cbtChannel" name="channel">
                                <label for="channel">iOS</label>
                            </div>
                        </div> -->
                        <!-- <input type="email" class="cbt-input-email" v-model.trim="cbtEmail" placeholder="Your Email Address">
                        <div class="cbt-btn">
                            <img src="../assets/images/pre/cbt_save_btn.png" v-if="!cbtFinshed" @click="cbtSave" class="cbt-btn-img" alt="">
                            <img src="../assets/images/pre/cbt_finshed_btn.png" v-else class="cbt-btn-img" alt="">
                        </div> -->
                    <!-- </div> -->
                    <!-- <div class="cbt-agree-tip-wrap">
                        <input type="checkbox" class="cbt-agree-checkbox" v-model="cbtCheckVal">
                        <p class="cbt-agree-tip">
                            Agree to the 
                            <router-link to="/terms_of_service">TERMS OF SERVICE</router-link> and <router-link to="/privacy_policy">PRIVACY POLICY</router-link>.
                        </p>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="cbt-text-box cbt-description" v-show="cbtShow">
            <div class="cbt-text">
                <p class="cbt-text-title">CLOSED BETA TEST</p>
                <div class="cbt-text-content">
                    <p>A closed beta test (CBT) will be held before the official release of Arknights.</p>
                    <p>During the CBT, players' opinions will be collected to improve the overall quality of the game, as well as make it more enjoyable.</p>
                    <p>We sincerely look forward to your participation, suggestions, and criticisms.</p>
                    <p>Please follow our official Discord for more information about the upcoming CBT:</p>
                    <p class="p-mg">Discord</p>
                    <p><a target="_blank" href="https://discord.gg/arknights">https://discord.gg/arknights</a></p>
                    
                    <p class="p-label p-mg">
                        <span class="label-key">Number of participants</span>
                        <span class="label-value">5,000 (Google Play)</span>
                    </p>
                    <p class="p-label">
                        <span class="label-key">Requirements</span>
                        <span class="label-value">any player who owns a Google Play account</span>
                    </p>
                    <p class="p-label">
                        <span class="label-key">Participation Method</span>
                        <span class="label-value">an email will be sent to those who have been selected for the participation of our CBT</span>
                    </p>

                    <p class="p-mg">CBT Registration Unavailable After 24:00, 19th December (UTC-7).</p>
                    <p>CBT Opens At 26th December - Ends At 2nd January (UTC-7).</p>
                </div>
            </div>
        </div>
        <div class="cbt-text-box cbt-note" v-show="cbtShow">
            <div class="cbt-text">
                <p class="cbt-text-title">PLEASE NOTE</p>
                <div class="cbt-text-content">
                    <p>1. Participants will be selected randomly, once the number of CBT registration exceeds 5k</p>
                    <p>2. We will only send the confirmation emails to players who are selected for our CBT</p>
                    <p>3. The installation of the CBT client will be explained step by step in the confirmation email</p>
                    <p>4. If you received a confirmation email, do not disclose its content to any third party</p>
                    <p>5. The confirmation email may appear in your spam box</p>
                    <p>6. Yostar will not be responsible for any failure of confirmation email delivery as long as the issue is not caused by Yostar</p>
                    <p>7. Player's progress will be cleared after the CBT</p>
                    <p>8. In-game purchase will be disabled during the CBT</p>
                    <p>9. The registration time and start time of the CBT may be changed without prior notice</p>
                    <p>10. Server maintenance may be conducted during the CBT period</p>
                    <p>11. Contents present in the CBT may differ from the release version of the game</p>
                </div>
            </div>
        </div>
        <footer-bar></footer-bar>
    </div>
</template>

<script>
import footerBar from "../components/footer";

export default {
    name: "pre-register",

    components: {
        "footer-bar": footerBar
    },
    data: () => ({
        goalList: [
            {
                num: 10000,
                text: "10K",
                lockImg: require("../assets/images/pre/goal01.png"),
                overImg: require("../assets/images/pre/goal01_over.png"),
            },
            {
                num: 20000,
                text: "20K",
                lockImg: require("../assets/images/pre/goal02.png"),
                overImg: require("../assets/images/pre/goal02_over.png"),
            },
            {
                num: 30000,
                text: "30K",
                lockImg: require("../assets/images/pre/goal03.png"),
                overImg: require("../assets/images/pre/goal03_over.png"),
            },
            {
                num: 50000,
                text: "50K",
                lockImg: require("../assets/images/pre/goal04.png"),
                overImg: require("../assets/images/pre/goal04_over.png"),
            },
            {
                num: 70000,
                text: "70K",
                lockImg: require("../assets/images/pre/goal05.png"),
                overImg: require("../assets/images/pre/goal05_over.png"),
            },
            {
                num: 100000,
                text: "100K",
                lockImg: require("../assets/images/pre/goal06.png"),
                overImg: require("../assets/images/pre/goal06_over.png"),
            }
        ],
        goalNumArr: [10000, 20000, 30000, 50000, 70000, 100000],
        currentNum: 0,
        checkVal: false,
        email: "",
        code: "",
        waitCode_show: false,
        waitTime: 45,
        waitTimer: null,
        prereg_finsh: false,
        // 
        cbtBtnOpen: false,
        cbtShow: false,
        cbtChannel: 'android',
        cbtEmail: '',
        cbtCheckVal: false,
        cbtFinshed: false,
    }),
    created() {
        this.getPreNum();
        alert("The pre-registration is closed.")
        this.$router.replace("/")
    },
    mounted() {
        if(this.HOME_FULLPAGE) {
            this.HOME_FULLPAGE.bodyScrollable(true);
        }
    },
    watch: {
        waitCode_show(val) {
            if(val) {
                // 开启定时器
                this.waitTimer = setInterval(() => {
                    this.waitTime = this.waitTime - 1;
                    if(this.waitTime <= 0) {
                        // 清除
                        clearInterval(this.waitTimer);
                        this.waitTimer = null;
                        this.waitTime = 45;
                        this.waitCode_show = false;
                    }
                }, 1000)
            }
        }
    },
    computed: {
        HOME_FULLPAGE() {
            return this.$store.state.HOME_FULLPAGE;
        },
        vali_email() {
            return this.$utils.trim(this.email);
        },
        vali_code() {
            return this.$utils.trim(this.code);
        },
        cbtBtn() {
            if(this.cbtBtnOpen) {
                return require("../assets/images/pre/cbt_btn_open.png")
            } else {
                return require("../assets/images/pre/cbt_btn_close.png")
            }
        }
    },
    methods: {
        awardImg(item) {
            if(item.num > this.currentNum) {
                return item.lockImg;
            } else {
                return item.overImg;
            }
        },
        check() {
            if(this.waitCode_show) {
                return;
            }
            
            if(!this.checkEmail(this.vali_email)) {
                alert("Please enter your vaild email.")
                return;
            }

            this.axios.get("/verifcode", {
                params: {
                    email: this.vali_email
                }
            }).then(v => {
                console.log(v)
                if(v.data.retcode == 0) {
                    // 发送邮件成功
                    this.waitCode_show = true;
                } else {
                    alert(v.data.msg)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        checkEmail(email) {
             // 邮箱验证正则
            const reg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

            if(email == '') {
                return false;
            } else if(!reg.test(email)) {
                return false;
            } else {
                return true;
            }
        },
        preBtn() {
            if(this.prereg_finsh) {
                return
            }
            if(!this.checkEmail(this.vali_email)) {
                alert("Please enter your vaild email.")
                return
            }
            if(!this.vali_code) {
                alert("Please enter verfication code.")
                return
            }
            if(!this.checkVal) {
                alert("Please agree to the terms of use and privacy policy in order to pre-register.")
                return
            }

            this.axios.get("/perreg", {
                params: {
                    email: this.vali_email,
                    code: this.vali_code,
                    "_o": this.$utils.getOrigin(this)
                }
            }).then(v => {
                console.log(v)
                if(v.data.retcode == 0) {
                    // 预约成功
                    gtag('event', 'sign_up', { method : 'Email' })     // 谷歌分析事件
                    fbq('track', 'CompleteRegistration')               // fb分析事件
                    
                    this.prereg_finsh = true;
                    alert("Pre-registration successful!")
                } else if(v.data.retcode == -3001) {
                    // 该邮箱已经预约
                    this.prereg_finsh = true;
                    alert("You have already pre-registered!")
                } else {
                    // 预约失败
                    alert("Pre-registration failed!")
                }
            }).catch(e => {
                console.log(e)
            })
        },
        getPreNum() {
            // 获取预约人数
            this.axios.get("/perreg_num").then(v => {
                console.log(v)
                if(v.data.retcode == 0) {
                    this.currentNum = v.data.data.prereg_num;
                }
            }).catch(e => {
                console.log(e)
            })
        },
        goalProcess(goalNum, index) {
            let process = 0;

            if(goalNum <= this.currentNum) {
                //当前阶段已完成
                process = 100
            } else {
                if(index == 0) {
                    if(goalNum - this.currentNum <= 10000) {
                        process = (10000 - goalNum + this.currentNum)/10000 * 100
                    }
                } else {
                    if(goalNum - this.currentNum <= this.goalNumArr[index] - this.goalNumArr[index-1]) {
                        process = (this.goalNumArr[index] - this.goalNumArr[index-1] - goalNum + this.currentNum)/(this.goalNumArr[index] - this.goalNumArr[index-1]) * 100
                    }
                }
            }
            
            return {
                "backgroundSize": `${process}% 100%`
            }
        },
        toggleBox(content) {
            if(content === 'cbt') {
                if(this.cbtBtnOpen) {
                    this.cbtShow = true
                } else {
                    // alert("Coming soon!")
                    this.cbtShow = true
                }
                
            } else if(content === 'pre') {
                this.cbtShow = false
            }
        },
        cbtSave() {
            if(!this.checkEmail(this.cbtEmail)) {
                alert("Please enter an email address bound to the OS you selected.")
                return
            }
            if(!this.cbtCheckVal) {
                alert("Please agree to the terms of use and privacy policy in order to register for closed beta test.")
                return
            }
            // 
            this.axios.get("/cbt", {
                params: {
                    "email": this.cbtEmail,
                    "channel": this.cbtChannel
                }
            }).then(v => {
                console.log(v)
                if(v.data.retcode === 0) {
                    // 预约成功
                    this.cbtFinshed = true;
                    alert("Successful!")
                } else if(v.data.retcode === -2001) {
                    // 已经预约过了
                    alert("You have already pre-registered!")
                } else {
                    // 预约失败
                    alert("Pre-registration failed!")
                }
            }).catch(e => {
                console.log(e)
                alert("Unexpected error")
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.pre-container {
    background: #141414 url("../assets/images/pre/bg.png") no-repeat;
    background-size: 100% auto;
    overflow: hidden;
    
    .pre-wrap {
        width: pxTorem(960px);
        min-height: pxTorem(900px);
        margin: pxTorem(430px) auto pxTorem(155px);
        display: flex;
        flex-direction: column;
        align-items: center;

        &.pre-warp--cbt {
            min-height: auto;
            margin: pxTorem(430px) auto 0;
        }

        .logo {
            width: pxTorem(475px);
        }
        .toggle-box {
            width: pxTorem(770px);
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: pxTorem(30px);

            .toggle-btn {
                display: block;
                flex: 1;
                max-width: 50%;
                cursor: pointer;

                &:first-of-type {
                    margin-right: pxTorem(50px);
                }

                &.toggle-btn--cbt {
                    &.active {
                        box-shadow: 0 0 20px 1px rgba(236, 194, 82, .7);
                    }
                }
                &.toggle-btn--pre {
                    &.active {
                        box-shadow: 0 0 20px 1px rgba(84, 195, 241, .7);
                    }
                }

                img {
                    width: 100%;
                }
            }
        }
        
        .pre-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            
            .input-wrap {
                width: pxTorem(596px);

                .input-email {
                    width: 100%;
                    height: pxTorem(46px);
                    position: relative;

                    input {
                        outline: none;
                        border: 0px;
                        padding: 0 1em;
                        position: absolute;
                        box-sizing: border-box;
                        width: 100%;
                        height: 100%;
                        background: #707070;
                        box-shadow: 0px 5px 8px 1px #595858 inset;
                        font-family: "SourceHanSansSubset";
                        color: #c3c3c3;
                        font-size: pxTorem(24px);
                        
                        &::-webkit-input-placeholder {
                            color: #c3c3c3;
                        }
                        &::-moz-placeholder {
                            color: #c3c3c3;
                        }
                        &:-ms-input-placeholder {
                            color: #c3c3c3;
                        }
                    }
                }

                .check-box {
                    margin-top: pxTorem(10px);
                    width: 100%;
                    height: pxTorem(46px);
                    display: flex;
                    justify-content: space-between;
                    align-content: space-between;
                    line-height: 0;

                    .check-input {
                        // width: pxTorem(300px);
                        flex: 1;
                        height: 100%;
                        outline: none;
                        border: 0px;
                        padding: 0 1em;
                        background: #707070;
                        box-shadow: 0px 5px 8px 1px #595858 inset;
                        font-family: "SourceHanSansSubset";
                        color: #c3c3c3;
                        font-size: pxTorem(24px);
                        
                        &::-webkit-input-placeholder {
                            color: #c3c3c3;
                        }
                        &::-moz-placeholder {
                            color: #c3c3c3;
                        }
                        &:-ms-input-placeholder {
                            color: #c3c3c3;
                        }
                    }
                    .check-btn {
                        height: 100%;
                        margin-left: pxTorem(12px);
                        cursor: pointer;
                        position: relative;

                        &::after {
                            content: "";
                            display: block;
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            background: url("../assets/images/pre/wait_code.png") no-repeat;
                            background-size: auto 100%;
                            background-position: center;
                            top: 0;
                            left: 0;
                            opacity: 0;
                            z-index: 2;
                        }

                        &.wait {
                            &::after {
                                opacity: 1;
                            }
                        }

                        .send-code {
                            height: 100%;
                        }
                        .wait-code {
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            z-index: 3;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            text-align: center;
                            cursor: not-allowed;

                            p {
                                font-size: pxTorem(24px);
                                color: #fff;
                                font-family: "SourceHanSansSubset";
                                font-weight: bold;
                                text-shadow: 0 0 3px #5e5e5e;
                            }
                        }
                    }
                }
                .cert-box {
                    margin-top: pxTorem(20px);
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    // align-content: center;
                    align-items: center;

                    input {
                        width: pxTorem(30px);
                        height: pxTorem(30px);
                        margin: 0;
                    }
                    p {
                        font-size: pxTorem(18px);
                        font-family: "SourceHanSansSubset";
                        font-weight: bold;
                        margin-left: pxTorem(10px);
                        color: #fff;

                        a {
                            text-decoration: underline;
                            color: #189ce0;
                        }
                    }
                }
            }
            .pre-reg-box {
                width: pxTorem(710px);
                position: relative;

                &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    left: 0;
                    background: url("../assets/images/pre/pre-register-finsh.png") no-repeat;
                    background-size: 100%;
                    opacity: 0;
                }

                &.finsh {
                    &::after {
                        opacity: 1;
                    }
                }

                img {
                    width: 100%;
                }

                .pre-reg-box-click {
                    position: absolute;
                    width: 90%;
                    height: 58%;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 3;
                    cursor: pointer;
                }
            }
            .goal-box {
                width: 100%;
                display: flex;
                justify-content: center;

                .goal {
                    position: relative;
                    &:not(:last-child) {
                        margin-right: pxTorem(7px);
                    }

                    .goal-proce{
                        display: block;
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: url("../assets/images/pre/goal_over.png") no-repeat;
                        background-size: 0% 100%;
                        background-position: left center;
                        z-index: 3;
                    }

                    img {
                        width: 100%;
                    }

                    .goal-tip {
                        font-family: "HelveticaInserat";
                        font-style: italic;
                        color: #fff;
                        position: absolute;
                        right: pxTorem(10px);
                        transform: translateY(-60%);
                        z-index: 5;
                    }
                }
            }
            .award-box {
                margin-top: pxTorem(94px);

                .award {
                    width: 100%;
                    img {
                        display: block;
                        width: 100%;
                    }
                }
            }
        }
        .cbt-content {
            .cbt-box {
                width: pxTorem(770px);
                box-sizing: border-box;
                padding: pxTorem(33px) pxTorem(120px);
                border: 1px solid #6f6f6f;
                background: #161616;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 0 auto;

                .cbt-box-tip {
                    color: #c3c3c3;
                    font-size: pxTorem(18px);
                    font-family: "SourceHanSansSubset";
                    font-weight: bold;
                    margin-bottom: pxTorem(20px);
                    letter-spacing: 1px;
                }
                .cbt-box-tip--close {
                    color: #c3c3c3;
                    font-size: pxTorem(18px);
                    font-family: "SourceHanSansSubset";
                    font-weight: bold;
                    letter-spacing: 1px;
                }
                
                .cbt-box-btn {
                    width: 100%;
                    height: pxTorem(45px);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: pxTorem(20px);

                    .cbt-input-email {
                        outline: none;
                        border: 0px;
                        padding: 0 1em;
                        box-sizing: border-box;
                        width: 70%;
                        height: pxTorem(45px);
                        background: #707070;
                        box-shadow: 0px 5px 8px 1px #595858 inset;
                        font-family: "SourceHanSansSubset";
                        color: #c3c3c3;
                        font-size: pxTorem(22px);

                        &::-webkit-input-placeholder {
                            color: #c3c3c3;
                        }
                        &::-moz-placeholder {
                            color: #c3c3c3;
                        }
                        &:-ms-input-placeholder {
                            color: #c3c3c3;
                        }
                    }
                    
                    /* .cbt-checkbox-box {
                        display: flex;
                        align-items: center;
                        margin-right: pxTorem(50px);
                        
                        .cbt-checkbox {
                            width: pxTorem(25px);
                            height: pxTorem(25px);
                            border: 1px solid lightblue;
                            margin: 0;
                        }
                        label {
                            font-family: "SourceHanSansSubset";
                            font-size: pxTorem(18px);
                            font-weight: bold;
                            color: #c3c3c3;
                            margin-left: pxTorem(5px);
                        }
                        .android-checkbox-box, .ios-checkbox-box {
                            display: flex;
                            align-items: center;
                            &.android-checkbox-box {
                                margin-right: pxTorem(20px);
                            }
                        }
                    } */
                    .cbt-btn {
                        height: 100%;
                        text-align: right;
                        font-size: 0;
                        cursor: pointer;
                        margin-left: pxTorem(20px);

                        .cbt-btn-img {
                            height: 100%;
                        }
                    }
                }
                .cbt-agree-tip-wrap {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-top: pxTorem(20px);
                    font-size: 0;

                    .cbt-agree-checkbox {
                        width: pxTorem(20px);
                        height: pxTorem(20px);
                        margin: 0 pxTorem(5px) 0 0;
                    }
                    .cbt-agree-tip {
                        color: #c3c3c3;
                        font-family: "SourceHanSansSubset";
                        font-size: pxTorem(18px);
                        font-weight: bold;

                        a {
                            text-decoration: underline;
                            color: #189ce0;
                        }
                    }
                }
            }
        }
    }
    .cbt-text-box {
        width: 100%;
        height: 0;
        padding-top: 36.72%;
        position: relative;

        &.cbt-description {
            background: url("../assets/images/pre/cbt_text_bg01.png") no-repeat;
            background-size: cover;
            margin-top: pxTorem(56px);
        }
        &.cbt-note {
            background: url("../assets/images/pre/cbt_text_bg02.png") no-repeat;
            background-size: cover;

            .cbt-text {
                color: #fff;
                .cbt-text-title {
                    font-size: pxTorem(24px);
                    font-family: "SourceHanSansSubset";
                    font-weight: bold;
                    display: inline-block;
                    border-bottom: 2px solid #fff;
                    color: #fff;
                    padding-right: pxTorem(60px);
                    padding-bottom: pxTorem(5px);
                    margin-bottom: pxTorem(10px);
                }
                .cbt-text-content {
                    width: 100%;
                    font-family: "SourceHanSansSubset";
                    font-size: pxTorem(18px);
                    color: #fff;
                }
            }
        }

        .cbt-text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: pxTorem(750px);
            
            .cbt-text-title {
                font-size: pxTorem(24px);
                font-family: "SourceHanSansSubset";
                font-weight: bold;
                display: inline-block;
                border-bottom: 2px solid #191919;
                color: #0f0f0f;
                padding-right: pxTorem(60px);
                padding-bottom: pxTorem(5px);
                margin-bottom: pxTorem(10px);
            }
            .cbt-text-content {
                width: 100%;
                font-family: "SourceHanSansSubset";
                font-size: pxTorem(18px);
                color: #161616;

                a {
                    color: #189ce0;
                }
                .p-mg {
                    margin-top: pxTorem(20px);
                }
                .p-label {
                    display: flex;

                    .label-key {
                        display: inline-block;
                        width: pxTorem(235px);
                    }   
                    .label-value {
                        flex: 1;
                    }
                }
            }
        }
    }
}
</style>
